import locales from "../locals/index"

// function getComponentClosestLanguage(element: HTMLElement): string {
//   let closestElement = element.closest("[lang]") as HTMLElement;
//   return closestElement ? closestElement.lang : "en";
// }

function fetchLocaleStringsForComponent(
  componentName: string,
  locale: string
): Promise<any> {
  return new Promise((resolve, reject) => {
    if(!locales[locale]) {
      console.warn(`no locale for ${locale}`)
      reject()
    }
    const conponent_local = locales[locale][componentName] || {}
    const res = locales[locale]['common'] ? {...conponent_local, ...locales[locale]['common']} : conponent_local
    resolve(res)
  })
  // return new Promise(
  //   (resolve, reject): void => {
  //     console.log(`/i18n/${componentName}.i18n.${locale}.json`)
  //     fetch(`/i18n/${componentName}.i18n.${locale}.json`).then(
  //       result => {
  //         if (result.ok) resolve(result.json());
  //         else reject();
  //       },
  //       () => reject()
  //     );
  //   }
  // );
}

export async function getLocaleComponentStrings(
  element: HTMLElement
): Promise<any> {
  let componentName = element.tagName.toLowerCase();
  // let componentLanguage = getComponentClosestLanguage(element);
  let componentLanguage = document.querySelector("html").getAttribute("lang") || 'en'
  let strings;
  try {
    strings = await fetchLocaleStringsForComponent(
      componentName,
      componentLanguage.toLowerCase()
    );
  } catch (e) {
    console.warn(
      `no locale for ${componentName} (${componentLanguage}) loading default locale en.`
    );
    strings = await fetchLocaleStringsForComponent(componentName, "en");
  }
  return strings;
}

export function variableString(str: string, replacement: string): string {
  
  const pattern = /{{(.*?)}}/g;
  return str.replace(pattern, replacement);
}
